import { ca } from '@cian/analytics';

export function trackShowListingProjects() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_listing_jk',
    useLastProducts: true,
  });
}
